import type { IntegrationHostName } from '../../../../contexts/ClientNameContext';

const INTEGRATION_SHARE_CTA_TARGETS: Record<IntegrationHostName, string> = {
  premiere:
    '[data-testid="share-active-document-cta"][data-integration-host="premiere"]',
  aftereffects:
    '[data-testid="share-active-document-cta"][data-integration-host="aftereffects"]',
};

export function getIntegrationShareCtaTarget(
  host: IntegrationHostName
): string {
  return INTEGRATION_SHARE_CTA_TARGETS[host];
}

export const INTEGRATION_SHARE_ONBOARDING_BASE = {
  delayMs: 1000,
  showAfterVisitNumber: 1,
  routes: ['/sequences'],
  placement: 'bottom' as const,
  precedence: 0,
  maxWidth: '360px',
  variant: 'Body' as const,
  icon: 'IconShare' as const,
};
